import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  Inject,
  Renderer2,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalTooltipOptions } from '@shared/v2/models';
import { RoutingService } from '@spartacus/core';
import { Observable, of, timer } from 'rxjs';
import { ModalTooltip } from './modal-tooltip';
import { SD_MODAL_TOOLTIP_OPTIONS_TOKEN } from './modal-tooltip-options.token';

@Component({
  selector: 'sd-modal-tooltip',
  templateUrl: './modal-tooltip.component.html',
  styleUrls: ['./modal-tooltip.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalTooltipComponent implements AfterContentInit {
  options$: Observable<ModalTooltipOptions> = of(this.options);
  tooltipOptions = this.options;

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly modalTooltip: ModalTooltip,
    private readonly routingService: RoutingService,
    private readonly renderer: Renderer2,
    private readonly elementRef: ElementRef,
    @Inject(SD_MODAL_TOOLTIP_OPTIONS_TOKEN) private readonly options: ModalTooltipOptions,
  ) {}

  ngAfterContentInit(): void {
    timer(this.tooltipOptions.lifeDuration ?? 3000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.closeModal());
  }

  closeModal(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'closing');
    timer(350)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.modalTooltip.close());
  }

  navigateToRoute(event?: Event): void {
    if (!this.tooltipOptions.route) {
      return;
    }

    event?.preventDefault();

    this.routingService.go(this.tooltipOptions.route);
    this.closeModal();
  }
}
